module.exports = __webpack_public_path__ + "img/non-p-vouchers.57cb1571.svg";